
import { defineComponent } from 'vue'

import { Endpoints } from '@octokit/types'
import Repo from './Repo.vue'

export default defineComponent({
  props: {
    repositories: {
      type: Array as () => Endpoints['GET /orgs/{org}/repos']['response']['data'],
      required: true,
    },
    langs: {
      type: Object as () => { [key: string]: { [key: string]: number } },
      required: false,
    },
  },
  components: {
    Repo,
  },
})
